import { Crosstab, CrosstabDefnItemSegment, CrosstabDefnRow } from "types";

import { envConfig } from "config";

/** Base of hardcoded data required by crosstab TS types.
 * TODO refactor ts types for crosstab. Reasons for hardcoding and refactor:
 * Reusing the CrosstabResults component in segment compare doesn't need all the properties used in crosstabs.
 * For segments comparison we're using the trick:
 *  1. the question "484"
 *  2. The "combined" answerGroupingUri : "sql/12615"
 */

/** rows is the config for the default questions */
const rows: CrosstabDefnRow[] = [
  {
    itemType: "question",
    id: "484",
    label: "",
    questionId: "484",
    segmentUuid: undefined,
    dateFilter: undefined,
    questionText: "Please indicate your gender",
    segmentName: undefined,
    answerChoices: [
      {
        answerChoiceId: 1536,
        label: "",
        answerChoiceText: "Male",
      },
      {
        answerChoiceId: 1537,
        label: "",
        answerChoiceText: "Female",
      },
    ],
    answerGrouping: undefined,
  },
  {
    itemType: "question",
    id: "7078",
    label: "",
    questionId: "7078",
    segmentUuid: undefined,
    dateFilter: undefined,
    questionText: "To what broad age group do you belong?",
    segmentName: undefined,
    answerChoices: [
      {
        answerChoiceId: 29516,
        label: "",
        answerChoiceText: "Under 18",
      },
      {
        answerChoiceId: 29517,
        label: "",
        answerChoiceText: "18 - 24",
      },
      {
        answerChoiceId: 30024,
        label: "",
        answerChoiceText: "25 - 29",
      },
      {
        answerChoiceId: 30025,
        label: "",
        answerChoiceText: "30 - 34",
      },
      {
        answerChoiceId: 29520,
        label: "",
        answerChoiceText: "35 - 44",
      },
      {
        answerChoiceId: 29521,
        label: "",
        answerChoiceText: "45 - 54",
      },
      {
        answerChoiceId: 29522,
        label: "",
        answerChoiceText: "55 - 64",
      },
      {
        answerChoiceId: 29523,
        label: "",
        answerChoiceText: "65 or older",
      },
    ],
    answerGrouping: undefined,
  },
  {
    itemType: "question",
    id: "4621",
    label: "",
    questionId: "4621",
    segmentUuid: undefined,
    dateFilter: undefined,
    questionText: "Which of the following best describes your race?",
    segmentName: undefined,
    answerChoices: [
      {
        answerChoiceId: 16963,
        label: "",
        answerChoiceText: "White or Caucasian",
      },
      {
        answerChoiceId: 16964,
        label: "",
        answerChoiceText: "Hispanic or Latino",
      },
      {
        answerChoiceId: 16965,
        label: "",
        answerChoiceText: "Black",
      },
      {
        answerChoiceId: 16966,
        label: "",
        answerChoiceText: "American Indian",
      },
      {
        answerChoiceId: 16967,
        label: "",
        answerChoiceText: "Aleut Eskimo",
      },
      {
        answerChoiceId: 16968,
        label: "",
        answerChoiceText: "Asian or Pacific Islander",
      },
      {
        answerChoiceId: 16969,
        label: "",
        answerChoiceText: "Other",
      },
    ],
    answerGrouping: undefined,
  },
  {
    itemType: "question",
    id: "625781",
    label: "",
    questionId: "625781",
    segmentUuid: undefined,
    dateFilter: undefined,
    questionText:
      "What is your total annual household income before taxes, including all members of your household and all sources of income?",
    segmentName: undefined,
    answerChoices: [
      {
        answerChoiceId: 3548614,
        label: "",
        answerChoiceText: "$0 - $29,999",
      },
      {
        answerChoiceId: 3548615,
        label: "",
        answerChoiceText: "$30,000 - $49,999",
      },
      {
        answerChoiceId: 3548616,
        label: "",
        answerChoiceText: "$50,000 - $74,999",
      },
      {
        answerChoiceId: 3548617,
        label: "",
        answerChoiceText: "$75,000 - $99,999",
      },
      {
        answerChoiceId: 3548618,
        label: "",
        answerChoiceText: "$100,000 - $149,999",
      },
      {
        answerChoiceId: 3548619,
        label: "",
        answerChoiceText: "$150,000 - $199,999",
      },
      {
        answerChoiceId: 3548620,
        label: "",
        answerChoiceText: "$200,000 - $299,999",
      },
      {
        answerChoiceId: 3548621,
        label: "",
        answerChoiceText: "$300,000 - $399,999",
      },
      {
        answerChoiceId: 3548622,
        label: "",
        answerChoiceText: "$400,000 or more",
      },
    ],
    answerGrouping: undefined,
  },
  {
    itemType: "question",
    id: "131788",
    label: "",
    questionId: "131788",
    segmentUuid: undefined,
    dateFilter: undefined,
    questionText: "Which of the following is the highest level of education you have attained?",
    segmentName: undefined,
    answerChoices: [
      {
        answerChoiceId: 1302079,
        label: "",
        answerChoiceText: "Less than high school",
      },
      {
        answerChoiceId: 1302080,
        label: "",
        answerChoiceText: "High school or GED",
      },
      {
        answerChoiceId: 1302081,
        label: "",
        answerChoiceText: "Some college, no degree",
      },
      {
        answerChoiceId: 1302082,
        label: "",
        answerChoiceText: "Associate degree",
      },
      {
        answerChoiceId: 1302083,
        label: "",
        answerChoiceText: "Bachelor's degree",
      },
      {
        answerChoiceId: 1302084,
        label: "",
        answerChoiceText: "Graduate or professional degree",
      },
    ],
    answerGrouping: undefined,
  },
  {
    itemType: "question",
    id: "497",
    label: "",
    questionId: "497",
    segmentUuid: undefined,
    dateFilter: undefined,
    questionText: "What type of area do you live in?",
    segmentName: undefined,
    answerChoices: [
      {
        answerChoiceId: 1576,
        label: "",
        answerChoiceText: "City",
      },
      {
        answerChoiceId: 1577,
        label: "",
        answerChoiceText: "Suburbs",
      },
      {
        answerChoiceId: 1578,
        label: "",
        answerChoiceText: "Rural Area",
      },
      {
        answerChoiceId: 28491,
        label: "",
        answerChoiceText: "Other",
      },
    ],
    answerGrouping: undefined,
  },
  {
    itemType: "question",
    id: "503",
    label: "",
    questionId: "503",
    segmentUuid: undefined,
    dateFilter: undefined,
    questionText: "What is your parental status?",
    segmentName: undefined,
    answerChoices: [
      {
        answerChoiceId: 1591,
        label: "",
        answerChoiceText: "Parent",
      },
      {
        answerChoiceId: 1592,
        label: "",
        answerChoiceText: "Grandparent",
      },
      {
        answerChoiceId: 1593,
        label: "",
        answerChoiceText: "Neither",
      },
    ],
    answerGrouping: undefined,
  },
];

/** hardcoded config to use a trick to compare segments:
 *  1. the question "484"
 *  2. The "combined" answerGroupingUri : "sql/12615"
 */
const segmentConfig: Omit<CrosstabDefnItemSegment, "id"> = {
  itemType: "segment",
  questionId: "484",
  dateFilter: {
    daysBefore: null,
    noDateFilter: true,
    relativeDateFilter: null,
    customDateFilter: null,
    customRelativeDateFilter: null,
    minDate: null,
    maxDate: null,
  },
  answerGrouping: {
    answerGroupingUri: envConfig.genderCombinedAnswerGrouping,
  },
};

const segmentCompareCrosstabSettings: Readonly<Crosstab & { segmentConfig: Omit<CrosstabDefnItemSegment, "id"> }> = {
  crosstabId: 0,
  name: "Segment Compare",
  defn: {
    rows,
    cols: [],
  },
  segmentConfig,
};

export default segmentCompareCrosstabSettings;
